import {Card, CloseButton, Col, Form, Row} from "react-bootstrap";
import Required from "../../Required";
import {monthsArray} from "../../../stores/StratProject/StrategyStore";
import Select from "react-select";
import React, {useEffect, useRef, useMemo} from "react";
import {useOutsideBounder} from "../../../hooks/useOutsideClick";
import useAPI from "../../../hooks/useAPI";
import {years} from "../../../helpers";

export default function NewMilestonesItem({milestones, onChange, data, index, trlsOptions, personInChargeOptions, isValidating,
                                              correctDates, notPassedMilestone, setNotPassedMilestone, resultsImpact}){
    const dateRef = useRef(null)
    const cardRef = useRef(null)
    const api = useAPI()
    useOutsideBounder(dateRef)

    useEffect(() => {
        if (notPassedMilestone === data){
            const cardPosition = cardRef.current.getBoundingClientRect()
            scrollTo(cardPosition.x, (cardPosition.y + cardPosition.bottom) / 2 - window.screen.availHeight / 2 + window.scrollY)
            setNotPassedMilestone(null)
        }
    }, [notPassedMilestone])

    const handleEditField = (value, idx, field) => {
        const milestonesCopy = [...milestones]
        milestonesCopy[idx][field] = value
        onChange([...milestonesCopy])
    }

    const resultsImpactOptions = useMemo(() => resultsImpact.map(value => ({
        label: `${getResultNum(value, resultsImpact)} ${value.name}`,
        value: value.id
    })).sort((opt1, opt2) => +opt1.label.split(' ')[0] - +opt2.label.split(' ')[0]), [resultsImpact])

    return (
        <Card className='mb-4' ref={cardRef}>
            <Card.Header className='p-4 d-flex justify-content-between'>
                <Card.Title>Веха {index + 1}</Card.Title>
                {!data.isReadonly && <CloseButton
                    onClick={() => onChange([...milestones.filter((v, idx) => idx !== index)], 'milestones')}
                    size="md"/>}
            </Card.Header>
            <Card.Body style={{padding: '30px 20px'}}>
                <Form.Group className='mb-4'>
                    <Form.Label>Название вехи <Required className="ml-2" /></Form.Label>
                    <Form.Control
                        required
                        value={data.name}
                        readOnly={data.isReadonly}
                        onChange={(event) => handleEditField(event.target.value, index, 'name')}
                        style={{backgroundColor: data.isReadonly ? '#e9ecef' : '#fff', opacity: 1}}
                    />
                    {isValidating && !data.name && <p style={{color: '#dc3545', fontSize: '.875rem'}}>Обязательное поле к заполнению</p>}
                </Form.Group>
                <Form.Group className='mb-4'>
                    <Form.Label>УГТ (план)</Form.Label>
                    <Select
                        required
                        value={trlsOptions.find((opt) => opt.value.id === data.trlId) || {label: 'Не указано', value: null}}
                        options={[{label: 'Не указано', value: null}, ...trlsOptions]}
                        onChange={(event) => handleEditField(event.value?.id ?? event.value, index, 'trlId')}
                        placeholder='Выберите значение из списка'
                    />
                </Form.Group>
                <Row>
                    <Col xs={5}>
                        <Form.Group>
                            <Form.Label>Дата выполнения (план) <Required className="ml-2" /></Form.Label>
                            <div className='d-flex gap-3' style={{width: '100%'}}>
                                <Select
                                    options={years.filter((year) => year >= 2023 && year >= correctDates.minDate.getFullYear() && year <= correctDates.maxDate.getFullYear())
                                        .map((year) => ({label: year, value: year}))}
                                    value={years.map((year) => ({label: year, value: year})).find((year) => year.value === data.yearPlan)}
                                    placeholder={'Выберите год'}
                                    isDisabled={data.projResultId}
                                    onChange={(event) => {
                                        handleEditField(event.value, index, 'yearPlan')
                                        handleEditField(null, index, 'monthPlan')
                                    }}
                                    styles={{
                                        container: (base) => ({...base, width: '50%'})
                                    }}
                                />
                                <Select
                                    options={monthsArray.filter((month, i) => !(data.yearPlan === correctDates.minDate.getFullYear() && i < correctDates.minDate.getMonth() ||
                                        data.yearPlan === correctDates.maxDate.getFullYear() && i > correctDates.maxDate.getMonth()))
                                        .map((month, i) => ({label: month, value: monthsArray.indexOf(month) + 1}))}
                                    placeholder={'Выберите месяц'}
                                    value={monthsArray.map((month, i) => ({label: month, value: i + 1})).find((month) => month.value === data.monthPlan) || null}
                                    onChange={(event) => handleEditField(event.value, index, 'monthPlan')}
                                    styles={{
                                        container: (base) => ({...base, width: '50%'})
                                    }}
                                />
                            </div>
                            {isValidating && !(data.monthPlan && data.yearPlan) &&
                                <p style={{color: '#dc3545', fontSize: '.875rem'}}>Обязательны для заполнения поля: год и месяц</p>}
                        </Form.Group>
                    </Col>
                    <Col xs={7}>
                        <Form.Group>
                            <Form.Label>Ответственный <Required className="ml-2" /></Form.Label>
                            <Select
                                placeholder="Начните вводить ФИО"
                                options={personInChargeOptions}
                                value={!!data.personsInCharge && !!data.personsInCharge[0] ?
                                    {
                                        label: `${data.personsInCharge[0].displayName ||
                                        `${data.personsInCharge[0].lastName} ${data.personsInCharge[0].firstName} ${data.personsInCharge[0].middleName}`}
                                             (${data.personsInCharge[0].post})`,
                                        value: data.personsInCharge[0]
                                    } :
                                    null
                            }
                                onChange={(event) => handleEditField([{...event.value}], index, 'personsInCharge')}
                            />
                            {isValidating && (!data.personsInCharge || !data.personsInCharge[0]) &&
                                <p style={{color: '#dc3545', fontSize: '.875rem'}}>Обязательное поле к заполнению</p>}
                        </Form.Group>
                    </Col>
                </Row>
                {resultsImpact && resultsImpact.length !== 0 && <Form.Group className="mt-4">
                    <Form.Label>Выдающийся результат/ веха СП, на который влияет проект</Form.Label>
                    <Select 
                        placeholder=''
                        options={resultsImpactOptions}
                        onChange={(event) => handleEditField(event.value, index, 'stratResultId')}
                        value={resultsImpactOptions.find(opt => opt.value === data.stratResultId)}
                    />
                </Form.Group>}
            </Card.Body>
        </Card>
    )
}

function getResultNum(result, results){
    const parent = result.parentId ? results.find(value => value.id === result.parentId) : null
    return parent ? `${parent.num}.${result.num}` : result.num + '.'
}